import React from 'react';
import styles from './PrivacyPolicy.less';

const PrivacyPolicy = () => {
  return <div className={styles.privacy}>Copyright © 2021 ZAMO - All Right Reserved</div>;
};

export default PrivacyPolicy;
